import CheckBox from "@/components/checkBox/checkBox.vue";

export default {
	components: { CheckBox },

	model: {
		prop: "days",
		event: "change",
	},

	watch: {
		// days when the outlet works
		days(updatedDays) {
			this.selectedDays = [...updatedDays];
		},
	},

	props: {
		// When true it disables toggling the days
		readonly: false,

		/*
		 * if you want to preselect the days in this component
		 * pass in an array containing values from 1 to 7
		 */
		days: {
			type: Array,
			default: () => [],
			validator: function (days) {
				const min = Math.min(...days),
					max = Math.max(...days),
					MONDAY = 1,
					SUNDAY = 7;

				if (min < MONDAY || max > SUNDAY) return false;

				return true;
			},
		},
	},

	data() {
		return {
			// number[] containing values from 1 to 7
			selectedDays: [],
			daysInWeek: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
		};
	},

	methods: { onChange },

	created() {
		this.selectedDays = this.days;
	},
};

function onChange(dayIndex) {
	dayIndex = Number(dayIndex);

	if (this.selectedDays.includes(dayIndex)) {
		// remove day
		this.selectedDays = this.selectedDays.filter((day) => day !== dayIndex);
	} else {
		// add day
		this.selectedDays.push(dayIndex);
	}

	this.$emit("change", this.selectedDays);
}
